<template>
    <v-menu
        v-model="menu"
        transition="scale-transition"
        offset-y
        :max-width="menuWidth"
        :close-on-click="false"
        :close-on-content-click="false"
      >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-bind="textFieldProps"
          :disabled="disabled"
          :loading="loading"
          :label="label"
          :value="formattedDate"
          v-on="on"
          readonly
        >
          <template v-slot:progress>
            <slot name="progress">
              <v-progress-linear color="primary" indeterminate absolute height="2"></v-progress-linear>
            </slot>
          </template>
        </v-text-field>
      </template>

      <v-card>
        <v-card-text class="px-0 py-0">
          <v-tabs fixed-tabs v-model="activeTab">
            <v-tab key="calendar-range">
              <slot name="firstIcon">
                <v-icon>mdi-calendar-range</v-icon>
              </slot>
            </v-tab>
            <v-tab key="calendar-multiselect" >
              <slot name="secondIcon">
                <v-icon>mdi-calendar-multiselect</v-icon>
              </slot>
            </v-tab>
            <v-tab-item key="calendar-range">
                <v-date-picker 
                  v-model="daterange" 
                  v-bind="dateProps" 
                  full-width 
                  range 
                  no-title
                ></v-date-picker>
            </v-tab-item>
            <v-tab-item key="calendar-multiselect">
              <v-date-picker 
                v-model="datemultiple" 
                v-bind="dateProps" 
                full-width 
                multiple 
                no-title
              ></v-date-picker>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <slot name="actions" :parent="this">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent()"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="okHandler()"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
          </slot>
        </v-card-actions>
      </v-card>
    </v-menu>
</template>
  
  <script>
  import moment from 'moment'
  // const DEFAULT_DATE = new Date()
  const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY'
  const DEFAULT_CLEAR_TEXT = 'CLEAR'
  const DEFAULT_OK_TEXT = 'OK'
  const DEFAULT_SIZE_WIDTH = 260


  export default {
    name: 'v-pcmdate-picker',
    model: {
      prop: 'date',
      event: 'input'
    },
    props: {
      date: {
        type: [Date, String,Object],
        default: null
      },
      disabled: {
        type: Boolean
      },
      loading: {
        type: Boolean
      },
      label: {
        type: String,
        default: ''
      },
      menuWidth: {
        type: Number,
        default: DEFAULT_SIZE_WIDTH
      },
      dateFormat: {
        type: String,
        default: DEFAULT_DATE_FORMAT
      },
      clearText: {
        type: String,
        default: DEFAULT_CLEAR_TEXT
      },
      okText: {
        type: String,
        default: DEFAULT_OK_TEXT
      },
      textFieldProps: {
        type: Object
      },
      dateProps: {
        type: Object
      },
    },
    data:() => ({
      daterange: [],
      datemultiple: [],
      activeTab: 0,
      display: false,
      menu:false,
      cancel:false,
    }),
    computed: {
      formattedDate () {
        if(this.activeTab == 0 && this.daterange.length >= 1){
          let maskrange = []
          this.daterange.forEach(date => {
            maskrange.push(moment(date).format(this.dateFormat))
          });
          return maskrange.join(' até ')
        }
        else if(this.activeTab == 1 && this.datemultiple.length >= 1){
          let maskrange = []
          this.datemultiple.forEach(date => {
            maskrange.push(moment(date).format(this.dateFormat))
          });
          return maskrange.join(', ')
        }
        else if (this.cancel){
          return ''
        }
        return moment().format(this.dateFormat)
      },
      selectedDate(){
        if(this.activeTab == 0){
          let dateAscending = this.daterange
          dateAscending.sort((a, b) => { return new Date(a) - new Date(b) })
          let dateSelected={
            dateIsRange: true,
            dates: dateAscending
          }
          return dateSelected
        }else{
          let dateAscending = this.datemultiple
          dateAscending.sort((a, b) => { return new Date(a) - new Date(b) })
          let dateSelected={
            dateIsRange: false,
            dates: dateAscending
          }
          return dateSelected
        }
      }
    },
    created() {
      this.daterange = [] 
      this.datemultiple = []
    },
    methods: {
      cancelEvent() {
        this.cancel = true
        this.resetPicker()
        this.clearPicker()
        this.$emit('input', null)
      },
      okHandler() {
        this.cancel= false
        this.$emit('input', this.selectedDate)
        this.resetPicker()
      },
      resetPicker() {
        this.menu = false
      },
      clearPicker() {
        this.menu = false
        this.daterange = [] 
        this.datemultiple = []
      },
    },
    watch: {
    }
  }
  </script>